import styled from "styled-components";

const PageContent = styled.div`
    padding-top: 100px;
    padding-bottom: ${({paddingBottom}) => paddingBottom ?? '80px'};
`;

export default PageContent;
